export default "__VITE_ASSET__Qt2LWFrD__"